import { ArticleMeta, articleTag } from "./types";

const META: ArticleMeta = {
    slug: "secure-delivery-pipeline",
    section: "portfolio",
    header: "Graphics & GPU Compute",
    title: "Discreet Engine",
    description: "An open-source particle, voxel, and physics engine built directly on the GPU.",
    tags: [
        articleTag("nvidea.svg"),
        articleTag("cpp.svg"),
        articleTag("vulkan-svgrepo-com.svg"),
        articleTag("opengl-svgrepo-com.svg"),
        articleTag("blender-svgrepo-com.svg"),
    ],
    url: "/articles/secure-delivery-pipeline",
};

export default META;
